import Classes from '../Assessment/Classes/Classes'
import { Route, Routes } from 'react-router-dom'
import Analytics from '../Analytics/Analytics'
import NotFoundPage from '../../NotFoundPage/NotFoundPage'
import DevelopmentalRubric from '../Assessment/DevelopmentalRubric/DevelopmentalRubric'
import Content from './Content/Content'
import AnalyticsCurriculum from '../Analytics/InternalLink/AnalyticsCurriculum/AnalyticsCurriculum'

const Dashboard = () => {
  return (
    <>
      <Routes>
        <Route index path='/*' element={<Content />} />
        <Route path='classes/*' Component={Classes} />
        <Route path='analytics/:code/analytics-curriculum/*' Component={AnalyticsCurriculum} />
        <Route path='analytics/*' Component={Analytics} />
        <Route path='developmental-rubrics/*' Component={DevelopmentalRubric} />
        <Route path='*' Component={NotFoundPage} />
      </Routes>
    </>
  )
}

export default Dashboard
